/* rk-ltb.js — JS de las secciones rk-ltb-* (/products/leather-tote-bag migrada de GemPages).
   Se carga con <script defer> desde cada sección que lo necesita. Todo va con guarda
   customElements.get() porque el mismo tag aparece en varias secciones de la página.

   Reglas del proyecto respetadas acá:
   - El add-to-cart va por AJAX a /cart/add.js con el variant DINÁMICO (SOP html→liquid).
     UpCart intercepta el click del form y abre su drawer solo; el AJAX queda de fallback.
   - Nada de localStorage (el tráfico de Meta llega en webviews con storage bloqueado).
   - Sin dependencias externas. */

(function () {
  'use strict';

  /* ---------------------------------------------------------------- variantes
     Un solo "store" por página: al cambiar la variante se actualizan el precio del
     buybox, el del sticky y el id de TODOS los formularios de add-to-cart. */
  var selected = null;

  function broadcastVariant(variant) {
    selected = variant;
    document.querySelectorAll('input[name="id"][data-rk-variant-input]').forEach(function (input) {
      input.value = variant.id;
    });
    document.querySelectorAll('[data-rk-price]').forEach(function (el) {
      el.innerHTML = variant.price;
    });
    document.querySelectorAll('[data-rk-compare]').forEach(function (el) {
      el.innerHTML = variant.compare;
      el.hidden = !variant.compare;
    });
    document.querySelectorAll('[data-rk-save]').forEach(function (el) {
      el.innerHTML = variant.save;
      el.hidden = !variant.save;
    });
    document.dispatchEvent(new CustomEvent('rk-ltb:variant', { detail: variant }));
  }

  /* Variante elegida en el selector del hero (rk-pdp-hero, aditivo leather-tote-bag): sincroniza sticky y formularios */
  document.addEventListener('rk-pdp:variant', function (e) { broadcastVariant(e.detail); });

  if (!customElements.get('rk-ltb-variants')) {
    customElements.define('rk-ltb-variants', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-rk-variant]'));
        this.buttons.forEach(function (btn) {
          btn.addEventListener('click', function () { self.select(btn); });
        });
      }

      select(btn) {
        this.buttons.forEach(function (other) {
          var on = other === btn;
          other.classList.toggle('is-selected', on);
          other.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        broadcastVariant({
          id: btn.dataset.rkVariant,
          price: btn.dataset.rkPrice || '',
          compare: btn.dataset.rkCompare || '',
          save: btn.dataset.rkSave || ''
        });
      }
    });
  }

  /* ------------------------------------------------------------- add to cart */
  if (!customElements.get('rk-ltb-atc')) {
    customElements.define('rk-ltb-atc', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.form = this.querySelector('form');
        this.btn = this.querySelector('button[type="submit"]');
        if (!this.form) return;
        this.form.addEventListener('submit', function (event) {
          event.preventDefault();
          self.add();
        });
      }

      add() {
        var self = this;
        var id = parseInt((this.form.querySelector('[name="id"]') || {}).value || '0', 10);
        var qty = parseInt((this.form.querySelector('[name="quantity"]') || {}).value || '1', 10) || 1;
        /* page product (id input follows the hero picker): use the hero's quantity selector */
        var pageQty = this.form.querySelector('[data-rk-variant-input]') && document.querySelector('[data-rk-qty-input]');
        if (pageQty) qty = parseInt(pageQty.value, 10) || qty;
        if (!id) return;
        if (this.btn) this.btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
        }).then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return self.afterAdd();
        }).catch(function () {
          if (!window.RkCart) { if (window.__rkCartEarly && window.__rkCartEarly.hold) window.__rkCartEarly.hold(); else window.location.href = '/cart'; }
        }).then(function () {
          if (self.btn) self.btn.disabled = false;
        });
      }

      afterAdd() {
        return fetch('/cart.js').then(function (res) { return res.json(); }).then(function (cart) {
          document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]')
            .forEach(function (el) { el.textContent = cart.item_count; });
        }).catch(function () { /* el contador lo refresca UpCart igual */ }).then(function () {
          ['cart:refresh', 'upcart:refresh', 'upcart:open'].forEach(function (name) {
            document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
          });
          setTimeout(function () {
            if (!window.RkCart) {
              window.location.href = '/cart';
            }
          }, 1200);
        });
      }
    });
  }

  /* ----------------------------------------------------------------- galería
     Track principal con scroll-snap + tira de miniaturas sincronizada + flechas.
     El original hace loop en las flechas: desde la última vuelve a la primera. */
  if (!customElements.get('rk-ltb-gallery')) {
    customElements.define('rk-ltb-gallery', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.track = this.querySelector('[data-rk-track]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-rk-slide]'));
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-rk-thumb]'));
        this.thumbTrack = this.querySelector('[data-rk-thumbtrack]');
        this.index = 0;
        if (!this.track || !this.slides.length) return;

        this.querySelectorAll('[data-rk-nav]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var step = btn.dataset.rkNav === 'prev' ? -1 : 1;
            var next = (self.index + step + self.slides.length) % self.slides.length;
            self.go(next);
          });
        });
        this.thumbs.forEach(function (thumb, i) {
          thumb.addEventListener('click', function () { self.go(i); });
        });
        this.track.addEventListener('scroll', function () {
          clearTimeout(self.timer);
          self.timer = setTimeout(function () { self.sync(); }, 90);
        }, { passive: true });
        this.mark();
      }

      go(i) {
        this.index = i;
        this.track.scrollTo({ left: this.slides[i].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.mark();
      }

      sync() {
        var left = this.track.scrollLeft + this.track.offsetLeft;
        var best = 0;
        var min = Infinity;
        this.slides.forEach(function (slide, i) {
          var d = Math.abs(slide.offsetLeft - left);
          if (d < min) { min = d; best = i; }
        });
        if (best !== this.index) { this.index = best; this.mark(); }
      }

      mark() {
        var self = this;
        this.thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === self.index);
        });
        var active = this.thumbs[this.index];
        if (active && this.thumbTrack && this.thumbTrack.scrollWidth > this.thumbTrack.clientWidth) {
          var target = active.offsetLeft - (this.thumbTrack.clientWidth - active.offsetWidth) / 2;
          this.thumbTrack.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
        }
      }
    });
  }

  /* --------------------------------------------------------------- carrusel
     Genérico de 1 ítem por vista con flechas y/o dots. Lo usan la barra de
     confianza en mobile y "Our First Creators" en mobile. */
  if (!customElements.get('rk-ltb-carousel')) {
    customElements.define('rk-ltb-carousel', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.track = this.querySelector('[data-rk-track]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-rk-slide]'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-rk-dot]'));
        this.index = 0;
        if (!this.track || this.slides.length < 2) return;

        this.querySelectorAll('[data-rk-nav]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var step = btn.dataset.rkNav === 'prev' ? -1 : 1;
            self.go((self.index + step + self.slides.length) % self.slides.length);
          });
        });
        this.dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () { self.go(i); });
        });
        this.track.addEventListener('scroll', function () {
          clearTimeout(self.timer);
          self.timer = setTimeout(function () { self.sync(); }, 90);
        }, { passive: true });
        this.mark();
      }

      go(i) {
        this.index = i;
        this.track.scrollTo({ left: this.slides[i].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.mark();
      }

      sync() {
        var left = this.track.scrollLeft + this.track.offsetLeft;
        var best = 0;
        var min = Infinity;
        this.slides.forEach(function (slide, i) {
          var d = Math.abs(slide.offsetLeft - left);
          if (d < min) { min = d; best = i; }
        });
        if (best !== this.index) { this.index = best; this.mark(); }
      }

      mark() {
        var self = this;
        this.dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === self.index);
        });
      }
    });
  }

  /* --------------------------------------------------------------- acordeón
     El original deja el contenido EN el DOM con altura 0 (visible para SEO):
     se anima max-height, nunca display:none. */
  if (!customElements.get('rk-ltb-accordion')) {
    customElements.define('rk-ltb-accordion', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-rk-item]'));
        this.single = this.hasAttribute('data-single');
        this.items.forEach(function (item) {
          var head = item.querySelector('[data-rk-head]');
          if (!head) return;
          head.addEventListener('click', function () { self.toggle(item); });
        });
      }

      toggle(item) {
        var self = this;
        var open = item.classList.contains('is-open');
        if (this.single && !open) {
          this.items.forEach(function (other) { if (other !== item) self.close(other); });
        }
        if (open) { this.close(item); } else { this.open(item); }
      }

      open(item) {
        var body = item.querySelector('[data-rk-body]');
        item.classList.add('is-open');
        var head = item.querySelector('[data-rk-head]');
        if (head) head.setAttribute('aria-expanded', 'true');
        if (body) body.style.maxHeight = body.scrollHeight + 'px';
      }

      close(item) {
        var body = item.querySelector('[data-rk-body]');
        item.classList.remove('is-open');
        var head = item.querySelector('[data-rk-head]');
        if (head) head.setAttribute('aria-expanded', 'false');
        if (body) body.style.maxHeight = '';
      }
    });
  }
})();
